/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from "react";
import {
    Button,
    FormControlLabel,
    FormLabel,
    Grid,
    IconButton,
    Paper,
    Radio,
    RadioGroup,
    TextField,
    ThemeProvider,
} from "@mui/material";
import {SEText} from "../../../../components/SEText";
import SEFilterSelect from "../../../../components/SEFilterSelect";
import styled from "styled-components";
import {RiSearchLine} from "react-icons/ri";
import {Controller, useForm} from "react-hook-form";
import {formatStringArray, sortArrayByDirection, sortArrayByProp,} from "../../../../utils/utils";
import {useQuery} from "react-query";
import {ArquivosAnexosService} from "../services";
import useRenderFormStore from "../../stores/useRenderFormStore";
import {removeEmpty} from "../../../../../utils/utils";
import {BaSeDialogContext} from "@base/react";
import useFormMutation from "../hooks/useFormMutation";
import theme from "../../../../mui-theme";
import {useHistory} from "react-router-dom";
import {useParams} from "react-router";
import {ArquivoAnexoInterface} from "../services/interfaces";
import {SEFormUserAction} from "../../../../components/SEFormUserAction";
import {ProjetoInterface} from "../../../../interfaces";

const CustomIcon = styled(RiSearchLine)(({theme}) => ({
    fill: theme.palette.primary.main,
    height: 26,
    width: 26,
    top: "calc(50% - .75em) !important",
}));

const FormularioArquivoAnexo = () => {
    const {showModal} = React.useContext(BaSeDialogContext);
    const history = useHistory();
    const {id} = useParams<{ id: string }>();

    const {data: filterOptions} = useQuery({
        queryFn: () => ArquivosAnexosService.getOptions(),
        queryKey: ["getOptions"],
        refetchOnMount: false,
    });

    const [tema, setTema] = useState("");
    const [obrigatoriedadeVisita, setObrigatoriedadeVisita] = useState(false);
    const {data: temas, refetch: refetchTemas} = useQuery<
        Array<ProjetoInterface>
    >({
        queryFn: () => ArquivosAnexosService.getTemas(tema),
        queryKey: ["getTemasArquivosAnexos", tema],
        refetchOnMount: false,
        enabled: Boolean(tema),
    });

    const {formData: editFormData, setFormData: setEditFormData} = useRenderFormStore();

    const [formData, setFormData] = useState<ArquivoAnexoInterface>(
        editFormData?.id
            ? editFormData
            : {
                id: undefined,
                uf: undefined,
                tema: undefined,
                subTema: undefined,
                nome: undefined,
                descricao: undefined,
                status: undefined,
                obrigatoriedade: undefined,
                arquivo: undefined,
                tipoAtendente: undefined,
            }
    );

    const {control, handleSubmit, reset, setError, watch} =
        useForm<ArquivoAnexoInterface>({
            defaultValues: formData,
        });
    const temaMacro = watch("tema");
    const subTema = watch("subTema");
    console.log('subTema', subTema)
    const obrigatoriedadeWatch = watch("obrigatoriedade");

    console.log('obrigatoriedadeWatch', obrigatoriedadeWatch)

    const onResetFields = () => {
        reset();
    };

    const goBack = () => {
        onResetFields();
        history.push(`/tabelas-de-controle/arquivos-anexos`);
    };

    useEffect(() => {
        if (temaMacro) {
            const temaMacroId =
                typeof temaMacro === "string" ? JSON.parse(temaMacro).id : temaMacro.id;
            setTema(temaMacroId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [temaMacro]);

    useEffect(() => {
        if (tema) {
            refetchTemas();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tema]);

    useEffect(() => {
        const fetchDataIfNecessary = async () => {
            if (id) {
                if (!editFormData) {
                    const data = await ArquivosAnexosService.read(id);
                    setEditFormData(data);
                    reset(data);
                } else {
                    setFormData(editFormData);
                }
            }
        };

        fetchDataIfNecessary();
    }, [id, editFormData, setFormData]);

    useEffect(() => {

        if(editFormData?.obrigatoriedade?.includes(['SOMENTE_PRIMEIRA_VISITA', 'SOMENTE_SEGUNDA_VISITA'])) {
            setObrigatoriedadeVisita(true);
            return;
        }

        if (obrigatoriedadeWatch === 'SIM') {
            setObrigatoriedadeVisita(true)
        }

        if (obrigatoriedadeWatch === 'NAO') {
            setObrigatoriedadeVisita(false)
        }
    }, [obrigatoriedadeWatch, editFormData])

    const {createMutation, updateMutation} = useFormMutation({
        showModal,
        service: ArquivosAnexosService,
        onCloseModalSuccess: () => goBack(),
        onCloseModalUpdate: () => goBack(),
    });

    const toDataURL = (file: File) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = reader.result as string;
                const base64 = base64String.split(",")[1];
                resolve(base64);
            };
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });

    const getBase64 = async (file: File) => {
        const base64 = await toDataURL(file);
        return base64;
    };

    const submitForm = async (dataForm: ArquivoAnexoInterface) => {
        if (!dataForm.arquivo.urlConteudo) {
            const base64 = await getBase64(dataForm.arquivo);

            dataForm.arquivo = {
                nome: dataForm.arquivo.name,
                base64,
                contentType: dataForm.arquivo.type,
                extensao: dataForm.arquivo.type,
            };
        }

        if (dataForm.id) {
            await updateMutation(removeEmpty(dataForm));
        } else {
            await createMutation(removeEmpty(dataForm));
        }
    };

    const OPCOES_OBRIGATORIEDADES = [
        {
            label: 'Não',
            value: 'NAO'
        },
        {
            label: 'Sim',
            value: 'SIM'
        },
    ]

    const OPCOES_VISITAS = [
        {
            label: 'Primeira Visita',
            value: 'SOMENTE_PRIMEIRA_VISITA'
        },
        {
            label: 'Segunda Visita',
            value: 'SOMENTE_SEGUNDA_VISITA'
        },
    ]

    return (
        <Paper
            sx={{
                display: "flex",
                alignItems: "center",
                padding: 2,
            }}
        >
            <ThemeProvider theme={theme}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <SEText
                            as="h2"
                            size={"medium"}
                            font="Mulish"
                            weight="bold"
                            color="#7B80FF"
                        >
                            {editFormData?.id ? "Editar" : "Incluir"}
                        </SEText>
                    </Grid>

                    <Grid container item spacing={3}>
                        <Grid item md={4}>
                            <Controller
                                control={control}
                                name="uf"
                                rules={{required: "Este campo é obrigatório"}}
                                render={({
                                             field: {value, onChange},
                                             fieldState: {error},
                                         }) => (
                                    <SEFilterSelect
                                        id={"uf"}
                                        defaultOption={"Selecione uma das opções"}
                                        IconComponent={CustomIcon}
                                        label="UF *"
                                        value={value}
                                        onChange={onChange}
                                        options={sortArrayByProp(filterOptions?.ufs, "sigla")}
                                        displayField="sigla"
                                        error={error}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item md={4}>
                            <Controller
                                control={control}
                                name="tema"
                                rules={{required: "Este campo é obrigatório"}}
                                render={({
                                             field: {value, onChange},
                                             fieldState: {error},
                                         }) => {
                                    return (
                                        <SEFilterSelect
                                            defaultOption={"Selecione uma das opções"}
                                            IconComponent={CustomIcon}
                                            label="Tema *"
                                            value={value?.id ?? ""}
                                            onChange={(selectedId) => {
                                                const selectedTema = filterOptions?.temas.find(
                                                    (tema) => tema.id === selectedId
                                                );
                                                onChange(selectedTema);
                                            }}
                                            options={sortArrayByProp(
                                                filterOptions?.temas,
                                                "descricao"
                                            )}
                                            displayField="descricao"
                                            valueField="id"
                                            error={error}
                                        />
                                    );
                                }}
                            />
                        </Grid>

                        <Grid item md={4}>
                            <Controller
                                control={control}
                                name="subTema"
                                rules={{required: "Este campo é obrigatório"}}
                                render={({
                                             field: {value, onChange},
                                             fieldState: {error},
                                         }) => (
                                    <SEFilterSelect
                                        id="subTema"
                                        label="Subtema *"
                                        displayField="descricao"
                                        defaultOption={"Selecione uma das opções"}
                                        IconComponent={CustomIcon}
                                        value={value}
                                        onChange={onChange}
                                        // @ts-ignore
                                        options={temas}
                                        error={error}
                                    />
                                )}
                            />
                        </Grid>

                        <Grid item md={4}>
                            <Controller
                                control={control}
                                name="tipoAtendente"
                                rules={{required: "Este campo é obrigatório"}}
                                render={({
                                             field: {value, onChange},
                                             fieldState: {error},
                                         }) => (
                                    <SEFilterSelect
                                        customLabel={formatStringArray}
                                        defaultOption={"Selecione uma das opções"}
                                        IconComponent={CustomIcon}
                                        label="Perfil Atendente *"
                                        value={value}
                                        onChange={onChange}
                                        options={sortArrayByDirection(
                                            filterOptions?.tipoAtendente ?? []
                                        )}
                                        error={error}
                                    />
                                )}
                            />
                        </Grid>
                    </Grid>

                    <Grid item md={12}>
                        <Controller
                            control={control}
                            name="nome"
                            rules={{required: "Este campo é obrigatório"}}
                            render={({
                                         field: {value, onChange},
                                         fieldState: {error},
                                     }) => (
                                <>
                                    <TextField
                                        id="nome"
                                        label="Título *"
                                        placeholder="Digite o título"
                                        fullWidth
                                        value={value || ""}
                                        onChange={onChange}
                                        inputProps={{maxLength: 144}}
                                    />
                                    {error && (
                                        <p style={{color: "red", marginTop: "8px"}}>
                                            {error.message}
                                        </p>
                                    )}
                                </>
                            )}
                        />
                    </Grid>

                    <Grid item md={12}>
                        <Controller
                            name="descricao"
                            control={control}
                            rules={{required: "Este campo é obrigatório"}}
                            render={({field, fieldState: {error}}) => (
                                <>
                                    <TextField
                                        id="descricao"
                                        label="Descrição *"
                                        placeholder="Digite aqui a descrição da anotação ou orientação"
                                        fullWidth
                                        multiline
                                        rows={4}
                                        onChange={field.onChange}
                                        value={field.value}
                                        sx={{
                                            "& .MuiInputBase-root": {
                                                height: "100%",
                                            },
                                        }}
                                    />
                                    {error && (
                                        <p style={{color: "red", marginTop: "8px"}}>
                                            {error.message}
                                        </p>
                                    )}
                                </>
                            )}
                        />
                    </Grid>

                    <Grid item md={4}>
                        <Controller
                            name="arquivo"
                            control={control}
                            rules={{required: "Este campo é obrigatório"}}
                            render={({
                                         field: {onChange, ref, value},
                                         fieldState: {error},
                                     }) => (
                                <>
                                    <div style={{display: "flex", alignItems: "center"}}>
                                        <TextField
                                            label="Arquivo *"
                                            placeholder="Faça o upload do arquivo..."
                                            fullWidth
                                            value={value?.name ?? editFormData?.arquivo?.nome}
                                            InputProps={{
                                                endAdornment: (
                                                    <IconButton component="label">
                                                        <img src={require("./downloadIcon.svg")} alt={""}/>
                                                        <input
                                                            type="file"
                                                            accept=".pdf, .xls"
                                                            hidden
                                                            ref={ref}
                                                            onChange={(event) => {
                                                                const file = event?.target?.files?.[0];

                                                                if (file) {
                                                                    const allowedExtensions = ["pdf", "xls"];
                                                                    const fileExtension = file.name
                                                                        .split(".")
                                                                        .pop()
                                                                        ?.toLowerCase()
                                                                        .toLowerCase();

                                                                    if (
                                                                        fileExtension &&
                                                                        allowedExtensions.includes(fileExtension)
                                                                    ) {
                                                                        onChange(file);
                                                                    } else {
                                                                        setError("arquivo", {
                                                                            message:
                                                                                "Por favor, selecione um arquivo válido (.pdf, .xls). ",
                                                                        });
                                                                    }
                                                                }
                                                            }}
                                                        />
                                                    </IconButton>
                                                ),
                                            }}
                                        />
                                    </div>
                                    {error && (
                                        <p style={{color: "red", marginTop: "8px"}}>
                                            {error.message}
                                        </p>
                                    )}
                                </>
                            )}
                        />
                    </Grid>

                    <Grid item md={12}>
                        <Controller
                            name="obrigatoriedade"
                            control={control}
                            rules={{required: "Este campo é obrigatório"}}
                            render={({field, fieldState: {error}}) => (
                                <>
                                    <FormLabel style={{
                                        fontFamily: "Mulish, sans-serif",
                                        fontSize: "14px",
                                        fontWeight: "bold",
                                    }}>Obrigatoriedade *</FormLabel>
                                    <RadioGroup row {...field}>
                                        {OPCOES_OBRIGATORIEDADES.map(
                                            ({label, value}) => (
                                                <FormControlLabel
                                                    key={value}
                                                    value={value}
                                                    control={<Radio/>}
                                                    label={label}
                                                />
                                            )
                                        )}
                                    </RadioGroup>
                                    {error && (
                                        <p style={{color: "red", marginTop: "8px"}}>
                                            {error.message}
                                        </p>
                                    )}
                                </>
                            )}
                        />
                    </Grid>
                    {
                        obrigatoriedadeVisita && (
                            <Grid item md={12}>
                                <Controller
                                    name="obrigatoriedade"
                                    control={control}
                                    rules={{required: "Este campo é obrigatório"}}
                                    render={({field, fieldState: {error}}) => (
                                        <>
                                            <RadioGroup row {...field}>
                                                {OPCOES_VISITAS.map(
                                                    ({label, value}) => (
                                                        <FormControlLabel
                                                            key={value}
                                                            value={value}
                                                            control={<Radio/>}
                                                            label={label}
                                                        />
                                                    )
                                                )}
                                            </RadioGroup>
                                            {error && (
                                                <p style={{color: "red", marginTop: "8px"}}>
                                                    {error.message}
                                                </p>
                                            )}
                                        </>
                                    )}
                                />
                            </Grid>
                        )
                    }


                    <Grid item md={12} display="flex" justifyContent="flex-end" gap={2}>
                        <Button variant="outlined" onClick={goBack}>
                            Cancelar
                        </Button>
                        <Button
                            style={{
                                backgroundColor: "#7B80FF",
                                color: "#FFFFFF",
                                fontFamily: "Mulish, sans-serif",
                            }}
                            variant="contained"
                            onClick={handleSubmit(submitForm)}
                            disabled={false}
                        >
                            {!!editFormData?.id ? "Editar" : "Incluir"}
                        </Button>
                    </Grid>

                    <Grid item md={12}>
                        <SEFormUserAction data={editFormData}/>
                    </Grid>
                </Grid>
            </ThemeProvider>
        </Paper>
    );
};

export default FormularioArquivoAnexo;
